import msalInstance from "utils/msal";

type IdTokenClaims = {
  roles: string[];
};

function getAuthority(): string[] {
  const allAccounts = msalInstance.getAllAccounts();
  if (allAccounts?.length > 0) {
    const account = allAccounts[0];
    if (account) {
      return (account?.idTokenClaims as IdTokenClaims).roles ?? [];
    }
  }

  return [];
}

export default getAuthority;
